const LOGIN_KEY = "dcs_login_time";

/**
 * Call this ONLY when user logs in
 */
export function setLoginTime() {
  const now = new Date().toISOString();
  localStorage.setItem(LOGIN_KEY, now);
  return now;
}

/**
 * Retrieve stored login time
 */
export function getLoginTime() {
  return localStorage.getItem(LOGIN_KEY);
}

/**
 * Optional: clear on logout
 */
export function clearLoginTime() {
  localStorage.removeItem(LOGIN_KEY);
}